import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { Location } from '@angular/common';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  tab: number = 1;
  carouselOptions: any = {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      0: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  };

  public faqs: Array<any> = [];

  constructor(
    private auth: AuthServiceService,
    private _location: Location,
    private seoService: SeoService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef
  ) {
    this.getFaq(1);
  }

  ngOnInit(): void {
    this.seoService.update({
      title: 'Kachiing Questions - FAQ',
      description: 'Frequently Asked Questions on Kachiing. Our platform is designed to provide answers to common questions and concerns, helping you navigate and make the most out of your Kachiing experience.'
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getFaq(id) {
    this.auth.getAllFaqQuestionBySection(id + 1)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.faqs = resp.body;
        this.cdr.detectChanges()
      });
  }
  goBack() {
    this.commonService.goBack();
  }
}
